import { Injectable } from '@angular/core';
import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { Observable } from 'rxjs';
import { TopicBackfillApiModel } from './models/topic-backfill.api.model';

@Injectable()
export class TopicBackfillApi {
    constructor (
        private neptuneApi: NeptuneApi
    ) { }

    /**
    * Create a new backfill request
    */
    requestBackfill(backfillRequest: TopicBackfillApiModel): Observable<void> {
        return this.neptuneApi.api<void>(
            '/backfills',
            backfillRequest,
            HttpVerbsEnum.POST
        );
    }

    /**
     * Get backfill with count for a particular saved search
     *
     */
    getAllWithCount(savedSearchId: number): Observable<TopicBackfillApiModel[]> {
        return this.neptuneApi.api<TopicBackfillApiModel[]>(
            `/backfills/saved-searches/${savedSearchId}`,
            null,
            HttpVerbsEnum.GET
        );
    }
}
